import { SOGetSubscription } from '../subscription/so-get-subscription';


export class SOPutInvoice {

  constructor(
    public uid: string,
    public ref: string = null,
    public exRef: string = null,
    public amountDue: number = null,
    public amountPaid: number = null,
    public amountRemaining: number = null,
    public dateDue: Date = null,
    public periodStart: Date = null,
    public periodEnd: Date = null,
    public paid: boolean = null,
    public subscription: SOGetSubscription = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutInvoice(
      'uid' in params ? params.uid : null,
      'ref' in params ? params.ref : null,
      'exRef' in params ? params.exRef : null,
      'amountDue' in params ? params.amountDue : null,
      'amountPaid' in params ? params.amountPaid : null,
      'amountRemaining' in params ? params.amountRemaining : null,
      'dateDue' in params ? params.dateDue : null,
      'periodStart' in params ? params.periodStart : null,
      'periodEnd' in params ? params.periodEnd : null,
      'paid' in params ? params.paid : null,
      'subscription' in params ? params.subscription : null,
    );
  }
}
